<template>
  <div class="about">
    <h2 class="title">Perfil Profissional</h2>
    <p>Tenho 8 anos de experiência no desenvolvimento de software, atuando em diversos segmentos, como financeiro, varejo e saúde. Ao longo dessa trajetória, desenvolvi habilidades técnicas e práticas em diversas plataformas, incluindo <b> Node.js(Nestjs, Express) C# e Java</b>, sempre assumindo papéis de destaque e protagonismo nos projetos em que estive envolvido.
    <br> 
    Sou Bacharel em Sistemas de Informação e, durante minha formação, enfrentei e superei diversos desafios, o que reforçou minha proatividade e dinamismo. Minha capacidade de adaptação e busca por soluções inovadoras me permite contribuir de maneira significativa em todas as fases de desenvolvimento de sistemas, superando as expectativas dos projetos e equipes.</p>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style scoped>

.about:last-child {
  margin-bottom: 0;
}

.title {
  color: #003147;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 10px;
}

p {
  color: #000000;
  font-weight: 300;
}

</style>